import { api } from "./api";

/** Backend: routes/me.ts (GET/DELETE /api/v1/me/connected-apps). */
const BASE = "/api/v1/me/connected-apps";

export interface ConnectedApp {
  clientId: string;
  /** Name the assistant registered with ("ChatGPT") — self-chosen, shown with `host`. */
  name: string | null;
  /** Where its redirect points: "chatgpt.com", "claude.ai". */
  host: string | null;
  scopes: string[];
  connectedAt: string | null;
  lastUsedAt: string | null;
}

export interface ConnectedAppsResponse {
  /** Whether this person may connect an assistant (feature config + subscription). */
  available: boolean;
  /** The address to paste into ChatGPT/Claude ("…/mcp"). */
  serverUrl: string;
  apps: ConnectedApp[];
}

/** `silent`: the card hides itself when this fails; a toast would be noise. */
export const getConnectedApps = (): Promise<ConnectedAppsResponse> =>
  api.get<ConnectedAppsResponse>(BASE, undefined, { silent: true });

/** Revokes the assistant's consent and tokens; its next request is refused. The caller toasts. */
export const disconnectApp = (clientId: string): Promise<void> =>
  api.delete<void>(`${BASE}/${encodeURIComponent(clientId)}`, undefined, { silent: true });
